import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import identityUtils from '../../utils/identityUtils';

// eslint-disable-next-line no-unused-vars
const useStyles = makeStyles((theme) => ({
  header: {
    width: '100%',
    padding: theme.spacing(1, 0),
    [theme.breakpoints.down('xs')]: {
      backgroundColor: theme.palette.blue.dark,
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2, 0, 1, 0),
      display: 'flex',
      alignItems: 'flex-end',
    },
    [theme.breakpoints.up('xl')]: {
      minHeight: 100,
      padding: theme.spacing(2, 0, 1, 0),
    },
  },
  logo: {
    margin: '0 auto',
    width: '300px !important',
    display: 'block !important',
    [theme.breakpoints.up('sm')]: {
      height: '51px !important',
    },
  },
  greeting: {
    color: theme.palette.common.white,
    float: 'right',
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
}));

const Header = ({ Logo }) => {
  const user = identityUtils.useLoggedInUserContext();
  const classes = useStyles();
  const [greetingMessage, setGreetingMessage] = useState('');

  useEffect(() => {
    if (user && user.profile && user.profile.name) {
      setGreetingMessage(`Welcome ${user.profile.name}`);
    }
  }, [user]);

  return (
    <Fragment>
      {!!greetingMessage && <div className={classes.greeting}>{greetingMessage}</div>}
      <header className={classes.header}>
        <Logo className={classes.logo} />
      </header>
    </Fragment>
  );
};

Header.propTypes = {
  Logo: PropTypes.any.isRequired,
};

export default Header;
